import _ from "lodash"
import parse from 'html-react-parser'

export function isHtmlString(string) {
  return _.isString(string) && /^\s*<[a-z\s]+>/i.test(string)
}

export function renderHtml(string) {
  return parse(string) 
}
